import React, { ReactElement } from "react";
import { EMPTY_VALUE_DASH } from "src/constants";

export const DISABLED_CELL: ReactElement<any> = <div className="disabled">{EMPTY_VALUE_DASH}</div>;

export const DisabledCell = ({ testid }: { testid: string }) => (
    <div data-testid={testid} className="disabled">
        {EMPTY_VALUE_DASH}
    </div>
);
